import React, { useState, useEffect } from "react";
import ServiceCard from "./ServiceCard";
import Loading from "./Loading";
import "../scss/service.scss";

import { getServices } from "../utils/API";

const ServicePanel = () => {
  const [loading, setLoading] = useState(true);
  const [servicessAvailable, setServicesAvailable] = useState([]);

  useEffect(() => {

    const fetchData = async () => {
      try {
        const res = await getServices();
        setServicesAvailable(res.data);
        setLoading(false);
      } catch (error) {
        console.error(
          "Un problème est survenu lors de la lecture des données !"
        );
      }

    };
    fetchData();
  }, []);

  return (
    <React.Fragment>
      {
        loading ? (
          <Loading />
        ) : (
          <div className="prestations">
            <h1>Nos prestations</h1>
            <div className="inner-container">
              {servicessAvailable.map((service, index) => (
                <ServiceCard
                  key={index}
                  id={service._id}
                  image={service.banner}
                  service={service.label}
                  price={service.price}
                  details={service.description}
                />
              ))}
            </div>
          </div >
        )
      }
    </React.Fragment>

  );
};

export default ServicePanel;
